/* Remy Bonjasky Lander
 * Lightweight progressive enhancement.
 * The <details> element handles open/close natively, but we add:
 *  - Close other items when one opens (accordion behavior)
 *  - Smooth-scroll for footnote anchors (e.g. clicking <sup> ref number)
 */
(function () {
  'use strict';

  // Single-open accordion for FAQ
  document.querySelectorAll('.rb-faq').forEach(function (faq) {
    var items = faq.querySelectorAll('.rb-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });
  });

  // Smooth-scroll for footnote references
  document.querySelectorAll('a[href^="#ref-"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.style.transition = 'background-color 1s';
        target.style.backgroundColor = 'rgba(12, 29, 60, 0.08)';
        setTimeout(function () { target.style.backgroundColor = ''; }, 1500);
      }
    });
  });
})();
